// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import { useToast } from "../context/ToastContext";
// import api from "../lib/api.ts";
// import leftbgimg from "../assets/leftbg.jpg";
// import bgimg from "../assets/loginbg.png";

// const ForgotPassword = () => {
//   const { showSuccess, showError } = useToast();
//   const [isLoading, setIsLoading] = useState(false);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({ defaultValues: { email: "" } });

//   const onSubmit = async ({ email }) => {
//     setIsLoading(true);
//     try {
//       await api.post(`/auth/forgot-password`, { email });
//       showSuccess("   A reset link has been sent to your email.");
//     } catch (e) {
//       showError(
//         "Something went wrong while sending the reset email. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div
//       className='min-h-[94vh] p-2 flex items-center justify-center bg-cover bg-center'
//       style={{ backgroundImage: `url(${bgimg})` }}
//     >
//       <div className='bg-white/20 backdrop-blur-lg w-full max-w-7xl rounded-3xl shadow-2xl border-[3px] border-white relative overflow-hidden'>
//         <div className='flex flex-col md:flex-row min-h-[800px] relative'>
//           {/* Left side - image panel */}
//           <div className='md:w-1/2 relative text-white p-10 overflow-hidden'>
//             <div
//               className='absolute inset-0 bg-cover bg-center'
//               style={{ backgroundImage: `url(${leftbgimg})` }}
//             >
//               <div className='absolute inset-0 bg-black opacity-20'></div>
//             </div>
//             <div className='relative z-10 text-center md:pt-20'>
//               <h2 className='text-[30px] md:text-[60px] font-semibold mb-2'>
//                 Forgot Password
//               </h2>
//               <p className='text-lg md:text-[20px] text-white/90 mb-6'>
//                 Enter your email to receive a reset link
//               </p>
//             </div>
//           </div>

//           {/* Right side - form */}
//           <div className='md:w-1/2 bg-white/70 backdrop-blur-md p-10 flex items-center justify-center  overflow-y-auto max-h-[800px]'>
//             <form onSubmit={handleSubmit(onSubmit)} className='w-full max-w-md'>
//               <div className='space-y-3'>
//                 <h3 className='text-2xl md:text-[28px] font-bold mb-1 text-[#131313]'>
//                   Forgot your password?
//                 </h3>
//                 <p className='text-[#13131399] pb-6 text-sm md:text-[16px]'>
//                   Enter the email you use to sign in. We'll email you a link to
//                   reset your password.
//                 </p>
//               </div>

//               <div className='mb-4'>
//                 <label className='block text-sm md:text-[16px] font-medium text-[#131313] mb-2'>
//                   Email address
//                 </label>
//                 <input
//                   type='email'
//                   placeholder='your@email.com'
//                   className={`w-full px-3 py-3 border ${
//                     errors.email ? "border-red-400" : "border-[#13131399]"
//                   } rounded-lg bg-white placeholder:text-text-[rgba(19,19,19,1)] focus:outline-none`}
//                   {...register("email", {
//                     required: "Please enter your email address.",
//                     pattern: {
//                       value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//                       message: "Please enter a valid email address.",
//                     },
//                   })}
//                 />
//                 {errors.email && (
//                   <p className='mt-1 text-sm text-red-500'>
//                     {errors.email.message}
//                   </p>
//                 )}
//               </div>

//               <div className='flex items-center justify-end gap-2'>
//                 <a
//                   href='/login'
//                   className='px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50'
//                 >
//                   Cancel
//                 </a>
//                 <button
//                   type='submit'
//                   disabled={isLoading}
//                   className='px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-60'
//                 >
//                   {isLoading ? "Sending..." : "Send reset link"}
//                 </button>
//               </div>

//               <p className='text-xs text-gray-500 mt-4'>
//                 Didn’t get the email? Check your spam folder or try again.
//               </p>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;

import { useState } from 'react';
import bgimg from "../assets/loginbg.png";
import { useLanguage } from '../context/LanguageContext';
import { forgotPassword } from '../services/authService.ts';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { translate } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError(translate("auth.forgotPassword.enterEmail"));
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError(translate("auth.forgotPassword.validEmail"));
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err?.message || 'Something went wrong while sending the reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ backgroundImage: `url(${bgimg})` }} className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-lg rounded-xl w-full max-w-[600px] shadow-lg p-8 mx-auto transition-all duration-300">
          {!submitted ? (
            <>
              {/* Header */}
              <div className="mb-8">
                <a
                  href="/login"
                  className="inline-flex items-center gap-2 text-primary font-medium mb-4 hover:underline"
                >
                  {translate("auth.forgotPassword.backToLoginLink")}
                </a>
                <h1 className="text-3xl font-bold text-[#2C3E50] mb-2">
                  {translate("auth.forgotPassword.title")}
                </h1>
                <p className="text-gray-600">
                  {translate("auth.forgotPassword.subtitle")}
                </p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-5">
                {error && (
                  <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                  </div>
                )}

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-[#2C3E50] mb-2">
                    {translate("auth.forgotPassword.emailLabel")}
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={translate("auth.forgotPassword.emailPlaceholder")}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-black bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-primary hover:bg-primary-dark disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition-colors duration-200"
                >
                  {loading ? translate("auth.forgotPassword.sending") : translate("auth.forgotPassword.sendResetLink")}
                </button>
              </form>

              {/* Footer */}
              <div className="mt-6 text-center">
                <p className="text-sm text-gray-600">
                  {translate("auth.forgotPassword.rememberPassword")}{' '}
                  <Link to="/login" className="text-primary font-semibold hover:underline">
                    {translate("auth.forgotPassword.signIn")}
                  </Link>
                </p>
              </div>
            </>
          ) : (
            <>
              {/* Success State */}
              <div className="text-center space-y-6">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100">
                  <svg
                    className="w-8 h-8 text-green-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-[#2C3E50] mb-2">
                    {translate("auth.forgotPassword.checkEmail")}
                  </h2>
                  <p className="text-gray-600">
                    {translate("auth.forgotPassword.resetLinkSent").replace("{email}", email)}
                  </p>
                </div>

                <div className="space-y-3">
                  <button
                    onClick={() => {
                      setSubmitted(false);
                      setEmail('');
                    }}
                    className="w-full bg-primary hover:bg-primary-dark text-white font-semibold py-3 rounded-lg transition-colors"
                  >
                    {translate("auth.forgotPassword.tryAnotherEmail")}
                  </button>
                  <a
                    href="/login"
                    className="block bg-gray-100 hover:bg-gray-200 text-[#2C3E50] font-semibold py-3 rounded-lg transition-colors text-center"
                  >
                    {translate("auth.forgotPassword.backToLogin")}
                  </a>
                </div>

                <p className="text-sm text-gray-500">
                  {translate("auth.forgotPassword.didNotReceive")}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
